/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreateUpdateProjectDtoFromJSON, CreateUpdateProjectDtoToJSON, } from './CreateUpdateProjectDto';
import { CreateUpdateQuoteDtoFromJSON, CreateUpdateQuoteDtoToJSON, } from './CreateUpdateQuoteDto';
/**
 * Check if a given object implements the CreateUpdateProjectQuoteDto interface.
 */
export function instanceOfCreateUpdateProjectQuoteDto(value) {
    return true;
}
export function CreateUpdateProjectQuoteDtoFromJSON(json) {
    return CreateUpdateProjectQuoteDtoFromJSONTyped(json, false);
}
export function CreateUpdateProjectQuoteDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'createUpdateProjectDto': json['createUpdateProjectDto'] == null ? undefined : CreateUpdateProjectDtoFromJSON(json['createUpdateProjectDto']),
        'createUpdateQuoteDto': json['createUpdateQuoteDto'] == null ? undefined : CreateUpdateQuoteDtoFromJSON(json['createUpdateQuoteDto']),
    };
}
export function CreateUpdateProjectQuoteDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'createUpdateProjectDto': CreateUpdateProjectDtoToJSON(value['createUpdateProjectDto']),
        'createUpdateQuoteDto': CreateUpdateQuoteDtoToJSON(value['createUpdateQuoteDto']),
    };
}
